<div class="hire-card">
    <div class="hire-card__icon" aria-hidden="true">
        <img class="hire-card__icon-img" [src]="iconSrc()" alt="">
    </div>
    <div class="hire-card__body">
        <div class="hire-card__title-row">
            <h3 class="hire-card__title">{{ data.title }}</h3>
            <span *ngIf="data.nuevo" class="hire-card__tag-new">Nuevo</span>
        </div>
        <p class="hire-card__desc">{{ data.description }}</p>
    </div>
    <button class="hire-card__btn" (click)="openExternalLink()">Descubre</button>
</div>
